module.exports = __webpack_public_path__ + "static/media/ayuda_grafica_barras.6dd86d36.gif";